import { type FC, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { Notification } from 'base-ui'

import { useCartIntermediateContext } from '../../context/CartIntermediateContext'

import { CartUrl } from './CartLink'

const CUSTOM_ERROR_MESSAGES: Record<string, ReactNode> = {
  PUT_MP_ENTRY_TO_CART_WITH_ODS: (
    <FormattedMessage
      id="cart.intermediate.cantMixMiraklAndODSProducts"
      values={{ link: <CartUrl /> }}
    />
  ),
  PUT_MP_ENTRY_TO_ERX_CARD_WITH_ERX: (
    <FormattedMessage
      id="cart.intermediate.cantMixMiraklAndERXProducts"
      values={{ link: <CartUrl /> }}
    />
  ),
}

export const CartIntermediateProductAddToCartErrorMessage: FC = () => {
  const { errorType } = useCartIntermediateContext()

  const message = errorType ? (
    CUSTOM_ERROR_MESSAGES[errorType]
  ) : (
    <FormattedMessage id="cart.notification.missingOrderDraft" />
  )

  return (
    <Notification
      className="mb-3"
      data-qa-id="product-add-to-cart-notification-cta-error"
      severity="error"
    >
      {message}
    </Notification>
  )
}
